<template>
  <v-navigation-drawer app clipped overflow :value="drawer" v-if="path !== '/login'">
    <v-list-item class="p-0">
      <v-list-item-content class="p-0">
        <v-list-item two-line class="p-8">
          <v-list-item-avatar class="m-8">
            <img class="avatar" :src="image" />
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{ username }}</v-list-item-title>

            <v-list-item-subtitle>{{ clock }}</v-list-item-subtitle>
            <v-list-item-subtitle>{{ new Date().toLocaleString('it-IT', {
                'weekday': 'long', 'month': 'long', 'day':
                  '2-digit', 'year': 'numeric'
              }).split(' ').map(el => el[0].toUpperCase() +
                el.slice(1)).join(' ')
            }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-content>
    </v-list-item>

    <v-divider></v-divider>

    <v-list dense nav>
      <div v-for="item in items" :key="item.title">
        <v-list-group :prepend-icon="item.icon" :value="path.includes(item.to)" v-if="item.submenus">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title :class="{
                'v-list-item--active': path == item.to
              }">{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item v-for="(submenu, i) in item.submenus" :key="i" :to="submenu.to" link :class="{
            'v-list-item--active': path == item.to,
            'ml-4': true
          }">
            <v-list-item-icon>
              <v-icon>{{ submenu.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ submenu.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-item :to="item.to" link v-else>
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </div>
    </v-list>

    <template v-slot:append>
      <div class="pa-2">
        <v-btn block color="accent" @click="logout">
          <v-icon>mdi-power</v-icon> Logout
        </v-btn>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Drawer',
  data() {
    return {
      clock: undefined,
      items: [
        { title: 'Dashboard', icon: 'mdi-view-dashboard', to: '/' },
        { title: 'Registro Generale', icon: 'mdi-table-large', to: '/registro-generale' },
        { title: 'Storico Vendite', icon: 'mdi-currency-eur', to: '/storico-vendite' },
        {
          title: 'Dich. di Vendita',
          icon: 'mdi-tablet-cellphone',
          to: 'usato',
          submenus: [
            {
              title: 'Clienti',
              icon: 'mdi-account-multiple',
              to: '/usato/clienti',
            },
          ],
        },
        {
          title: 'Magazzino',
          icon: 'mdi-sitemap',
          to: 'magazzino',
          submenus: [
            {
              title: 'Smartphone',
              icon: 'mdi-cellphone-iphone',
              to: '/magazzino/smartphones',
            },
            {
              title: 'Sim',
              icon: 'mdi-sim',
              to: '/magazzino/sims',
            },
            {
              title: 'Accessori',
              icon: 'mdi-power-plug',
              to: '/magazzino/accessori',
            },
            {
              title: 'Ricambi',
              icon: 'mdi-wrench',
              to: '/magazzino/ricambi',
            },
            {
              title: 'Servizi',
              icon: 'mdi-flag-variant',
              to: '/magazzino/servizi',
            },
            {
              title: 'Formazione',
              icon: 'mdi-lightbulb-on',
              to: '/magazzino/formazione',
            },
          ],
        },
        {
          title: 'Riparazioni',
          icon: 'mdi-screwdriver',
          to: 'riparazioni',
          submenus: [
            {
              title: 'Bytewood',
              icon: 'mdi-usb',
              to: '/riparazioni/bytewood',
            },
            {
              title: 'Clienti',
              icon: 'mdi-account-multiple',
              to: '/riparazioni/clienti',
            },
          ],
        },
        {
          title: 'Preordini',
          icon: 'mdi-format-list-bulleted',
          to: 'preordini',
          submenus: [
            {
              title: 'Devices',
              icon: 'mdi-cellphone-iphone',
              to: '/preordini/devices',
            },
            {
              title: 'Accessori',
              icon: 'mdi-power-plug',
              to: '/preordini/accessori',
            },
            {
              title: 'Ricambi',
              icon: 'mdi-wrench',
              to: '/preordini/ricambi',
            },
          ],
        },
        { title: 'Movimenti', icon: 'mdi-clipboard-flow', to: '/movimenti' },
        { title: 'Note', icon: 'mdi-book', to: '/note' },
        { title: 'Clienti', icon: 'mdi-account-multiple', to: '/clienti' },
        { title: 'Camere', icon: 'mdi-webcam', to: '/camere' },
        { title: 'Categorie', icon: 'mdi-tag-multiple', to: '/categorie' },
        { title: 'Media', icon: 'mdi-folder-multiple-image', to: '/media' },
        { title: 'Strumenti di Contabilità', icon: 'mdi-matrix', to: '/strumenti-di-contabilita' },
        { title: 'Profilo', icon: 'mdi-account-circle', to: '/profilo' },
      ],
      image: `${process.env.VUE_APP_API}/img/system/avatar-placeholder.png`,
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('logout')
      this.$router.push('/login')
    },
    checkTime(i) {
      if (i < 10) {
        i = '0' + i
      } // add zero in front of numbers < 10
      return i
    },
    setClock() {
      var today = new Date()
      var h = today.getHours()
      var m = today.getMinutes()
      var s = today.getSeconds()
      h = this.checkTime(h)
      m = this.checkTime(m)
      s = this.checkTime(s)
      this.clock = `${h}:${m}:${s}`
    },
    startClock() {
      setInterval(this.setClock, 1000)
    },
  },
  computed: {
    ...mapGetters(['username', 'email', 'getProfile', 'drawer']),
    path() {
      return this.$route.path
    },
  },
  watch: {
    getProfile: {
      handler(val) {
        if (val.profile.avatar) {
          this.image = val.profile.avatar
        } else {
          this.image = `${process.env.VUE_APP_API}/img/system/avatar-placeholder.png`
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.$store.dispatch('fetchProfile').then((res) => {
      this.image = res.data.avatar
    })
    this.startClock()
  },
}
</script>

<style scoped>
h1 {
  text-align: center;
}

.p-0 {
  padding: 0;
}

.p-8 {
  padding: 8px;
}

.p-16 {
  padding: 16px;
}

.m-8 {
  margin: 8px !important;
}

.avatar {
  background-color: #a4a4a5;
}
</style>
